(function (scope) {
  'use strict';
  const norm = value => String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  const values = list => (Array.isArray(list) ? list : []).map(norm).filter(Boolean);
  const overlap = (a, b) => a.some(value => b.includes(value));
  function select(current, candidates) {
    const makers = values(current.makers), models = values(current.models);
    const type = norm(current.type), gens = current.gens || [];
    if (!makers.length || !models.length || !type) return [];
    const seen = new Set();
    return candidates.filter(p => {
      if (!p.id || p.id === current.id || !p.url || !p.available || seen.has(p.id)) return false;
      const pm = values(p.models);
      if (!pm.length || !values(p.makers).length || norm(p.type) !== type) return false;
      const pg = p.gens || [];
      if (gens.some(g => pg.some(h => g.id && g.id === h.id))) return false;
      const sharedModels = models.filter(m => pm.includes(m));
      if (sharedModels.some(m => {
        const left = gens.filter(g => norm(g.model) === m && makers.includes(norm(g.make)));
        const right = pg.filter(g => norm(g.model) === m && makers.includes(norm(g.make)));
        return !left.length || !right.length || left.some(g => !g.id) || right.some(g => !g.id);
      })) return false;
      seen.add(p.id);
      return true;
    }).sort((a, b) => {
      const ar = !overlap(makers, values(a.makers)) ? 2 : overlap(models, values(a.models)) ? 0 : 1;
      const br = !overlap(makers, values(b.makers)) ? 2 : overlap(models, values(b.models)) ? 0 : 1;
      return ar - br || String(a.title).localeCompare(String(b.title), 'en') || String(a.id).localeCompare(String(b.id));
    }).slice(0, 4);
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = {select};
  if (typeof document === 'undefined') return;
  scope.PdpOtherVehicles = {select};
  async function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    try {
      const current = JSON.parse(root.querySelector('[data-other-current]').textContent);
      const endpoint = new URL(root.dataset.feed, location.origin);
      if (root.dataset.previewTheme) endpoint.searchParams.set('preview_theme_id', root.dataset.previewTheme);
      const candidates = [];
      let page = 1, pages = 1;
      do {
        root.dataset.phase = 'catalog-' + page;
        endpoint.searchParams.set('page', String(page));
        const response = await fetch(endpoint, {credentials: 'same-origin', signal: AbortSignal.timeout(30000)});
        if (!response.ok) throw new Error('Catalog page ' + page + ' HTTP ' + response.status + ' at ' + response.url);
        const payload = await response.json();
        if (!Array.isArray(payload.products) || !Number.isInteger(payload.pages) || payload.pages < 1 || payload.page !== page) throw new Error('Invalid catalog pagination');
        candidates.push(...payload.products);
        pages = payload.pages;
        page++;
      } while (page <= pages);
      const chosen = select(current, candidates);
      if (!chosen.length) { root.dataset.phase = 'empty'; return; }
      root.dataset.phase = 'cards';
      const cards = await Promise.all(chosen.map(async p => {
        const url = new URL(p.url, location.origin);
        url.searchParams.set('view', 'pdp-other-card');
        if (root.dataset.previewTheme) url.searchParams.set('preview_theme_id', root.dataset.previewTheme);
        const response = await fetch(url, {credentials: 'same-origin', signal: AbortSignal.timeout(30000)});
        if (!response.ok) throw new Error('Card HTTP ' + response.status);
        const html = await response.text();
        if (!html.includes('pdp-other__card') || html.includes('Liquid error')) throw new Error('Invalid product card');
        return html;
      }));
      root.querySelector('[data-other-grid]').innerHTML = cards.join('');
      root.dataset.phase = 'ready';
      root.hidden = false;
      root.querySelectorAll('[data-other-cart]').forEach(form => form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('button'), status = form.querySelector('[role="status"]');
        if (button.disabled) return;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        try {
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const body = new FormData(form);
          if (cart && typeof cart.getSectionsToRender === 'function') {
            body.append('sections', cart.getSectionsToRender().map(s => s.id));
            body.append('sections_url', location.pathname);
            if (cart.setActiveElement) cart.setActiveElement(document.activeElement);
          }
          const response = await fetch(form.action + '.js', {method: 'POST', body, headers: {'Accept': 'application/json','X-Requested-With': 'XMLHttpRequest'}});
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add item. Please try again.');
          if (cart && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          }
          else location.assign(root.dataset.cartUrl);
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {source:'product-form', productVariantId:body.get('id'), cartData:data});
          }
          status.textContent = 'Added to cart';
        } catch (error) { status.textContent = error.message; }
        finally { button.disabled = false; button.removeAttribute('aria-busy'); }
      }));
    } catch (error) { root.dataset.phase = 'error'; console.warn('Other vehicle recommendations unavailable:', error); }
  }
  const start = container => container.querySelectorAll('[data-pdp-other-vehicles]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start(document));
  else start(document);
  document.addEventListener('shopify:section:load', event => start(event.target));
})(typeof window !== 'undefined' ? window : globalThis);
